import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';

import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ButtonModule, IconModule, StructuredListModule, TilesModule } from 'carbon-components-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-tour-guide-dialog',
  templateUrl: './tour-guide-dialog.component.html',
  styleUrls: ['./tour-guide-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatCardModule,
    MatIconModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    MatExpansionModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule
],
  
})
export class TourGuideDialogComponent {

  title:string = '';
  desciption:string = '';
  customerName = '';
  currentStep: number = 0;
  totalSteps: number = 0;
  constructor(private dialogRef: MatDialogRef<MatDialogComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any){  
    dialogRef.disableClose = true;
    this.title = data.title;
    this.desciption = data.desciption;
    this.currentStep = data.stepCount;
    this.totalSteps = data.totalSteps;
  }
}
